module.exports = __webpack_public_path__ + "img/leftTop.446b2185.png";